
export async function glideCompareInit() {
    let elements = document.querySelectorAll('.glide--compare');
    if (elements.length) {
        let {default: Glide, Breakpoints, Controls} = await import('@glidejs/glide/dist/glide.modular.esm');
        elements.forEach(element => {
            let compareSlider = new Glide(element, {
                gap: 0,
                perView: 4,
                breakpoints: {
                    1024: {
                        perView: 3
                    },
                    992: {
                        perView: 2
                    },
                    768: {
                        perView: 1
                    }
                }
            }).mount({Controls, Breakpoints});
    
            let tabElList = document.querySelectorAll('#compareTab a[data-bs-toggle="tab"]')
            tabElList.forEach(tabEl => {
                tabEl.addEventListener('shown.bs.tab', function () {
                    compareSlider.update();
                })
            });
        });
    }
    
}